<template>
  <div class="xhm-layout">
    <!--工具栏-->
    <el-form :inline="true" :model="pageRequest" :size="size">
      <el-form-item label="登录名">
        <el-input v-model="pageRequest.login_name"></el-input>
      </el-form-item>
      <el-form-item label="手机号">
        <el-input v-model="pageRequest.phonenumber"></el-input>
      </el-form-item>
      <el-form-item label="角色">
        <el-select v-model="pageRequest.roleId" clearable>
          <el-option
            v-for="item in roles"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="注册时间">
        <el-date-picker
          v-model="pageRequest.create_time"
          type="daterange"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          value-format="timestamp"
          :default-time="['00:00:00', '23:59:59']"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <kt-button
          icon="fa fa-search"
          label="查询"
          perms="sys:role:view"
          type="primary"
          @click="onSub"
        />
      </el-form-item>
      <el-form-item>
        <kt-button
          icon="fa fa-search"
          label="新增"
          perms="sys:role:view"
          type="primary"
          @click="handleNew"
        />
      </el-form-item>
    </el-form>
    <!-- <div class="toolbar" style="float:right;padding-top:10px;padding-right:15px;">
    	  	表格显示列界面
    	  	<table-column-filter-dialog
    	  	  	ref="tableColumnFilterDialog"
    	  	  	:columns="columns"
    	  	  	@handleFilterColumns="handleFilterColumns"
    	  	></table-column-filter-dialog>
    	</div> -->
    <!--表格内容栏-->
    <!-- <kt-table
    	  	permsEdit="sys:user:edit"
    	  	permsDelete="sys:user:delete"
    	  	:data="pageResult"
    	  	:columns="filterColumns"
    	  	@handleCurrentChange="handleRoleSelectChange"
    	  	@findPage="findPage"
    	  	@handleEdit="handleEdit"
			@handleDelete="handleDelete"
    	></kt-table> -->
    <!--新增编辑界面-->

    <kt-table
      :loadingData="loading"
      :dataFront="filterColumns"
      :tableData="pageResult.content"
      highlight
      @handleCurrentChange="handleRoleSelectChange"
    ></kt-table>

    <kt-pag
      :pageCount="pageResult.totalSize"
      :currentPage="pageResult.pageNum"
      :limit="pageResult.pageSize"
      @onChange="handleChange"
    ></kt-pag>

    <el-dialog
      :title="operation ? '新增' : '编辑'"
      width="40%"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="dataForm"
        label-width="100px"
        :rules="dataFormRules"
        ref="dataForm"
        :size="size"
        label-position="right"
      >
        <el-form-item label="ID" prop="id" v-if="false">
          <el-input
            v-model="dataForm.id"
            :disabled="true"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="登录名" prop="login_name">
          <el-input v-model.trim="dataForm.login_name"></el-input>
        </el-form-item>
        <el-form-item label="用户名" prop="user_name">
          <el-input v-model.trim="dataForm.user_name"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phonenumber">
          <el-input v-model.trim="dataForm.phonenumber"></el-input>
        </el-form-item>
        <el-form-item label="机构" prop="deptName">
          <popup-tree-input
            :data="deptData"
            :props="deptTreeProps"
            :prop="dataForm.deptName"
            :nodeKey="'' + dataForm.id"
            :currentChangeHandle="deptTreeCurrentChangeHandle"
          >
          </popup-tree-input>
        </el-form-item>
        <el-form-item label="角色" prop="userRoles">
          <el-select
            v-model="dataForm.userRoles"
            multiple
            placeholder="请选择"
            style="width: 100%"
            >
            <el-option
              v-for="item in roles"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="归属上级" prop="parent_id">
          <el-input v-model.trim="dataForm.parent_id"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            type="password"
            placeholder="请设置6-16位的密码"
            v-model.trim="dataForm.password"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPassword">
          <el-input
            type="password"
            placeholder="请设置6-16位的密码"
            v-model.trim="dataForm.checkPassword"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="dataForm.remarks"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :size="size" @click.native="dialogVisible = false"
          >取消</el-button
        >
        <el-button
          :size="size"
          type="primary"
          @click.native="submitForm"
          :loading="editLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PopupTreeInput from "@/components/PopupTreeInput";
// import KtTable from "@/views/Core/KtTable";
import KtTable from "@/views/Comm/KtTable";
import KtPag from "@/views/Comm/KtPag";
import KtButton from "@/views/Core/KtButton";
// import TableColumnFilterDialog from "@/views/Core/TableColumnFilterDialog";
import { format } from "@/utils/comm";
import crypto from "crypto";
export default {
  components: {
    PopupTreeInput,
    KtTable,
    KtPag,
    KtButton,
    // TableColumnFilterDialog
  },
  data() {
    let validatePass = (rule, value, callback) => {
      value === ""
        ? callback(new Error("请再次输入密码"))
        : value !== this.dataFormRules.password
        ? callback(new Error("两次输入密码不一致!"))
        : callback();
    };
    return {
      loading: false,
      size: "small",
      columns: [],
      deptData: [],
      filterColumns: [
        { prop: "id", label: "ID", width: 80, sortable: false },
        { prop: "login_name", label: "登录名", width: 140, sortable: false },
        { prop: "user_name", label: "用户名", width: 140, sortable: false },
        { prop: "roleNames", label: "角色", width: 90, sortable: false },
        { prop: "deptName", label: "机构", width: 90, sortable: false },
        { prop: "phonenumber", label: "手机", width: 140, sortable: false },
        // { prop: "shop_id", label: "云树店铺ID", width: 140, sortable: false },
        // { prop: "isbangding", label: "绑定状态", width: 100, sortable: false, render: (h, { row, column }) => (h('span', `${row[column.prop] ? '已绑定' : '否'}`)) },
        {
          prop: "create_time",
          label: "注册时间",
          minWidth: 140,
          sortable: false,
          render: (h, { row, column }) => {
            return h("span", format(row[column.prop]));
          },
        },
        { prop: "remarks", label: "备注", minWidth: 100, sortable: false },
        {
          prop: "status",
          label: "状态",
          width: 60,
          render: (h, { row, column }) => {
            let status = row[column.prop] === 1 ? true : false;
            return h("el-switch", {
              props: {
                value: status,
                activeColor: "#13ce66",
                inactiveColor: "#ff4949",
              },
              on: {
                change: (e) => {
                  this.handleStatus(e, row);
                },
              },
            });
          },
        },
        {
          label: "操作",
          fixed: "right",
          width: 100,
          render: (h, { row }) => {
            return h(
              "el-button",
              {
                props: { icon: "el-icon-edit", size: "mini" },
                on: {
                  click: () => {
                    this.handleEdit({ row: row });
                  },
                },
              },
              "编辑"
            );
          },
        },
      ],
      pageRequest: { pageNum: 1, pageSize: 10 },
      pageResult: {},
      operation: false, // true:新增, false:编辑
      dialogVisible: false, // 新增编辑界面是否显示
      editLoading: false,
      dataFormRules: {
        login_name: [
          { required: true, message: "请输入登录名", trigger: "blur" },
        ],
        user_name: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        phonenumber: [
          { required: true, message: "请输入手机号", trigger: "blur" },
        ],
        userRoles: [{ required: true, message: "请选择角色", trigger: "blur" }],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 6, max: 16, message: "请设置6-16位的密码!", trigger: "blur" },
        ],
        // checkPassword: [
        //   { required: true, validator: validatePass, trigger: "blur" },
        // ],
      },
      deptId: "",
      deptName: "",
      // 新增编辑界面数据
      dataForm: {
        id: 0,
        login_name: "",
        user_name: "",
        phonenumber: "",
        parent_id: "",
        password: "",
        deptId: "",
        deptName: "",
        status: 1,
        remarks: "",
        userRoles: [],
        checkPassword: "",
        password: "",
      },
      deptData: [],
      deptTreeProps: {
        label: "name",
        children: "children",
      },
      roles: [],
      onSwitch: false,
      subLoading: false,
      dialog: false,
      uid: null,
    };
  },
  mounted: function () {
    this.findPage();
    this.findDeptTree();
  },
  methods: {
    // 获取分页数据
    findPage: function (/**data*/) {
      // let url = {}
      // if (data !== null) {
      //   	this.pageRequest = data.pageRequest
      // }
      let { pageNum, pageSize } = this.pageRequest;
      let params = { ...this.pageRequest };
      delete params.pageNum;
      delete params.pageSize;
      params.page = pageNum;
      params.limit = pageSize;
      this.loading = true;
      this.$api.menu.sysuser(params).then((res) => {
        //this.onSwitch = true
        this.loading = false;
        this.pageResult = res.data;
        if (this.roles.length === 0) {
          this.findUserRoles();
        }
      });
      // }).then(data != null ? data.callback : "")
    },
    handleChange: function ({ page, limit }) {
      this.pageRequest = Object.assign({}, this.pageRequest, {
        pageNum: page,
        pageSize: limit,
      });
      this.findPage();
    },
    // 加载用户角色信息
    findUserRoles: function () {
      this.$api.menu.sysroleFindPage().then((res) => {
        // 加载角色集合
        this.roles = res.data.content;
      });
    },
    // 获取部门列表
    findDeptTree: function () {
      this.$api.deptApi.getAllList().then((res) => {
        this.deptData = res.data;
      });
    },
    //查询
    onSub() {
      // this.onSwitch = true
      this.pageRequest.pageNum = 1;
      this.findPage(null);
    },
    // 批量删除
    handleDelete: function (data) {
      this.$api.menu
        .delSysuser(data.params[0].id)
        .then(data != null ? data.callback : "");
    },
    handleStatus: function (e, row) {
      let msg = e ? "启用" : "禁用";
      this.$confirm(`是否继续${msg}${row.login_name}该用户?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.loading = true;
          let params = { row: row };
          this.handleEdit(params, false);
          this.dataForm.status = e ? 1 : 0;
          const { status, message } = await this.$api.menu.updateUser(
            this.dataForm
          );
          this.$message({
            message: status === "0" ? "操作成功" : message,
            type: status === "0" ? "success" : "error",
          });
          if (status === "0") {
            this.findPage();
          }
        })
        .catch(() => {});
    },
    // 显示新增界面
    handleAdd: function () {
      this.dialogVisible = true;
    },
    handleRoleSelectChange(val) {
      if (val == null) {
        return;
      }
      this.uid = val.id;
    },
    handShare() {
      if (this.uid == null) {
        this.$message({
          showClose: true,
          message: "请先选择账户在操作!",
          type: "warning",
        });
        return;
      }
      this.subLoading = true;
      this.$api.menu.authShare(this.uid).then((res) => {
        if (res.status == 0) {
          this.dialog = true;
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error",
          });
        }
        this.subLoading = false;
      });
    },

    // 显示编辑界面
    handleEdit: function (params, isPase = true) {
      this.dialogVisible = isPase;
      this.operation = false;
      this.dataForm = {
        id: params.row.id,
        login_name: params.row.login_name,
        user_name: params.row.user_name,
        phonenumber: params.row.phonenumber,
        deptId: this.deptId,
        deptName: this.deptName,
        userRoles: [],
        status: params.row.status,
        remarks: params.row.remarks,
      };

      let userRoles = [];
      for (let i = 0, len = params.row.sysRoles.length; i < len; i++) {
        userRoles.push(params.row.sysRoles[i].roleId);
      }
      this.dataForm.userRoles = userRoles;
    },
    // 显示新增界面
    handleNew: function (params, isPase = true) {
      this.dialogVisible = isPase;
      this.operation = true;
      this.dataForm = {
        id: 0,
        login_name: "",
        user_name: "",
        phonenumber: "",
        parent_id: "",
        password: "",
        deptId: "",
        deptName: "",
        status: 1,
        remarks: "",
        userRoles: [],
        checkPassword: "",
        password: "",
      };
    },
    // 编辑和新增
    submitForm() {
      this.$confirm("是否确认提交?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.editLoading = true;
          if(!this.dataForm.parent_id){
            this.dataForm.parent_id=0
          }
          let values = { ...this.dataForm };
          let { password } = values;
          let md5 = crypto.createHash("md5");
          md5.update(password);
          values.password = md5.digest("hex");
          const { status, message } = await this.$api.menu.updateUser(values);
          this.$message({
            message: status === "0" ? "操作成功" : message,
            type: status === "0" ? "success" : "error",
          });
          if (status === "0") {
            this.findPage(null);
          }
          this.onSwitch = false;
          this.editLoading = false;
          this.dialogVisible = false;
        })
        .catch(() => {});
    },
    // 菜单树选中
    deptTreeCurrentChangeHandle(data, node) {
      this.deptId = data.id;
      this.deptName = data.name;
      this.dataForm.deptId = data.id;
      this.dataForm.deptName = data.name;
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue, index) {
      return format(row[column.property]);
    },
    // 处理表格列过滤显示
    displayFilterColumnsDialog: function () {
      this.$refs.tableColumnFilterDialog.setDialogVisible(true);
    },
    // 处理表格列过滤显示
    handleFilterColumns: function (data) {
      this.filterColumns = data.filterColumns;
      this.$refs.tableColumnFilterDialog.setDialogVisible(false);
    },
    timeStr(row, column, cellValue, index) {
      return format(row[column.property]);
    },
  },
};
</script>